import { useEffect, useRef } from 'react';
import { byJSONviewer } from './json';
import './json.css';

export const EasyJsonViewer = ({ data }: { data: unknown }) => {
  const elementRef = useRef<HTMLPreElement>(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    return byJSONviewer(element, data, {
      forceMonospace: false,
      themeToggle: false,
      fontSizeControls: true,
      copyButton: true,
      controlsSize: 'small',
      controlsCompact: true,
      controlsPosition: 'top',
      withLinks: true,
      collapsed: true,
      rootCollapsible: true,
      withQuotes: true,
      chunkSize: 100,
      chunkLatency: 25,
      bigNumbers: false,
      statusBar: false,
      displayContainer: false
    });
  }, [data]);

  return <pre ref={elementRef} className={`light`} />;
};
